import { API_BASE_URL } from "../auth/apiClient";
import authService from "../auth/authService";
import { ACTIVITY_API_CONFIG } from "./apiConfig";
import type { ActivityEvent } from "./types";

/**
 * Fire-and-forget. Deliberately bypasses the `api` axios instance: its 401/403
 * interceptors would log the user out or redirect to /403 if tracking failed.
 */
function send(event: ActivityEvent): void {
  const token = authService.getToken();
  if (!token) return;

  fetch(`${API_BASE_URL}${ACTIVITY_API_CONFIG.TRACK}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(event),
  }).catch(() => {
    // Tracking must never affect the user
  });
}

export function trackPageView(path: string): void {
  send({ event_type: "page_view", path });
}

/**
 * Record a report download from the current page.
 * @param report Stable report name (no dates), used to group download stats.
 * @param extra  Filename, filters, period, format — anything that varies per download.
 */
export function trackDownload(report: string, extra?: Record<string, unknown>): void {
  send({ event_type: "download", path: window.location.pathname, resource: report, extra });
}
